import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PainSection from "@/components/PainSection";
import Solution from "@/components/Solution";
import Calculator from "@/components/Calculator";
import HowItWorks from "@/components/HowItWorks";
import Segments from "@/components/Segments";
import NotUs from "@/components/NotUs";
import BeforeAfter from "@/components/BeforeAfter";
import Insights from "@/components/Insights";
import Pricing from "@/components/Pricing";
import Implementation from "@/components/Implementation";
import Faq from "@/components/Faq";
import DemoForm from "@/components/DemoForm";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CookieBanner from "@/components/CookieBanner";
import "@/App.css";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "CliniAtiva",
  description:
    "Automação inteligente de atendimento e agendamento via WhatsApp com agentes de IA para clínicas, estética, odontologia e petshops.",
  sameAs: ["https://instagram.com/cliniativa"],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+55-85-9403-2594",
    contactType: "sales",
    availableLanguage: "Portuguese",
  },
};

export default function App() {
  useEffect(() => {
    const stored = window.localStorage.getItem("cliniativa-theme");
    if (stored === "dark") document.documentElement.classList.add("dark");

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[var(--paper)] text-[var(--ink)]">
      <Seo
        title="CliniAtiva — IA que atende, agenda e confirma no seu WhatsApp"
        siteName="CliniAtiva"
        description="Agentes de IA para WhatsApp que respondem em segundos, agendam, confirmam e recuperam clientes 24h por dia. Sua equipe atende pessoas. A CliniAtiva cuida do resto."
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PainSection />
        <Solution />
        <Calculator />
        <HowItWorks />
        <Segments />
        <NotUs />
        <BeforeAfter />
        <Insights />
        <Pricing />
        <Implementation />
        <Faq />
        <DemoForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieBanner />
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}
